import React, { useContext } from 'react';
import { IBLSpinLoader } from '../../IBLSpinLoader';
import externalImg from '../assets/images/external-link.svg';
import { AccountContext } from '../context';
import { useTranslation } from 'react-i18next';

const Footer = ({ isSubmitting, handleSubmit }) => {
  const { stripeBillingURL, handleBillingClick, notification } =
    useContext(AccountContext);
  const { t } = useTranslation('library');

  return (
    <div
      className={`w-layout-hflex-account-ui account-submit-btn-container ${
        stripeBillingURL !== '' ? 'space-between' : ''
      }`}
    >
      {!!notification?.message && (
        <div
          style={{ position: 'relative', marginBottom: '10px', top: 'unset' }}
          className={`pwd-notification-container`}
        >
          <div
            className={`pwd-notification-text ${
              notification?.success ? 'success' : 'error'
            }`}
          >
            {notification?.message}
          </div>
        </div>
      )}

      <a
        onClick={!isSubmitting ? handleSubmit : (e) => { e.preventDefault() }}
        href="#"
        className={`default-btn form-submit-btn w-button ${
          !!isSubmitting ? 'disabled' : ''
        } `}
      >
        {t('Save')}{' '}
        {!!isSubmitting && <IBLSpinLoader color="#FFFFFF" size={16} />}
      </a>
    </div>
  );
};

export default Footer;
